import styles from "./index.module.scss";
export default function FilterMobileOptions(props: {
  optionVacant: any[];
  occupancy: any;
  setOccupancy: (arg0: any) => void;
  title: string;
  border?: boolean;
  disabledOptions?: string[];
}) {
  return (
    <div className={props.border ? styles.mainDiv : "none"}>
      <div className={styles.title}>{props.title}</div>
      <div className={styles.capsuleSelect1}>
        {props.optionVacant.map((option) => {
          const isDisabled = props.disabledOptions?.includes(option.name);
          return (
            <div
              key={`${option.name}-${JSON.stringify(option)}`}
              className={`${styles.option} ${
                props?.occupancy === option?.name ? `${styles.active}` : ""
              } ${isDisabled ? styles.disabled : ""}`}
              onClick={() => {
                if (isDisabled) return;
                props?.occupancy === option.name
                  ? props.setOccupancy(null)
                  : props.setOccupancy(option.name);
              }}
              aria-disabled={isDisabled}
            >
              {option.name}
            </div>
          );
        })}
      </div>
    </div>
  );
}
